import { invoke } from 'lodash';
import { useCallback, useState } from 'react';
import { meetingApi } from '../services/tcMeeting';

export const useDeleteMeetingRemark = () => {
  const [isLoading, setLoading] = useState(false);

  const deleteRemark = useCallback(async (data, options) => {
    try {
      setLoading(true);
      const response = await meetingApi.deleteRemarks(data);
      invoke(options, 'onSuccess', response.data);
      setLoading(false);
      return response.data;
    } catch (err) {
      setLoading(false);
      invoke(options, 'onError', err);
      return {};
    }
  }, []);

  return { deleteRemark, isLoading };
};
